import {
  RANK_RANK_APPS_SUCCESS,
  RANK_RANKS_SUCCESS,
  OTHER_RANK_APPS_SUCCESS,
  OTHER_RANK_LOADING,
  RANK_LOADING,
} from '../constants/topn';

const initState = {
  rankApps: {
    apps: null,
    code: null,
    loading: false,
    pagenation: {
      count: 0,
    },
  },
  otherRanksApps: {
    apps: null,
    code: null,
    loading: false,
    pagenation: {
      count: 0,
    },
  },
  allRanksAndApps: [],
};

const topn = (state = initState, action = {}) => {
  switch (action.type) {
    case OTHER_RANK_APPS_SUCCESS:
      return {
        ...state,
        otherRanksApps: {
          ...action.payload,
          apps:
            action.payload.refresh || action.payload.code !== state.otherRanksApps.code
              ? action.payload.apps
              : [...state.otherRanksApps.apps, ...action.payload.apps],
          loading: false,
          code: action.payload.code,
          pagenation: {
            count: action.payload.count,
          },
        },
      };
    case RANK_RANK_APPS_SUCCESS:
      return {
        ...state,
        rankApps: {
          ...action.payload,
          apps:
            action.payload.refresh || action.payload.code !== state.rankApps.code
              ? action.payload.apps
              : [...state.rankApps.apps, ...action.payload.apps],
          loading: false,
          code: action.payload.code,
          pagenation: {
            count: action.payload.count,
          },
        },
      };
    case RANK_RANKS_SUCCESS:
      return { ...state, allRanksAndApps: action.payload };
    case OTHER_RANK_LOADING:
      return {
        ...state,
        otherRanksApps: {
          ...state.otherRanksApps,
          loading: action.loading,
        },
      };
    case RANK_LOADING:
      return {
        ...state,
        rankApps: {
          ...state.rankApps,
          loading: action.loading,
        },
      };
    default:
      return state;
  }
};

export default topn;
